import React from 'react'
import { connect } from 'react-redux'
import GreyBig from './../GreyBig'
import Split from './Split'
import InterestRate from './InterestRate'
import RepaymentType from './RepaymentType'

class Details extends React.Component {
  render() {
    const {
      loanDetail: {
        interestType,
        summary: {
          fixedRateLabel,
          variableRateLabel,
          offsetAccountLabel,
          fixedRepaymentTypeLabel,
          fixedInterestPeriodLabel,
          overallLoanTermLabel,
          variableRepaymentTypeLabel,
        },
        calculator,
      },
    } = this.props

    return(
      <div>
        { (interestType === 'split') ?
          <Split /> 
          :
          <div className='card-body'>
            <GreyBig size='4' grey='Repayment of' big={ calculator.repaymentWithFrequency }/>
            <GreyBig
              size='4'
              grey='Rate'
              big={
                <InterestRate
                  interestType={ interestType }
                  fixedRateLabel={ fixedRateLabel }
                  variableRateLabel={ variableRateLabel }
                />
              }
            />
            <GreyBig
              size='4'
              grey='Repayment type'
              big={
                <RepaymentType
                  interestType={ interestType }
                  fixedRepaymentTypeLabel={ fixedRepaymentTypeLabel }
                  variableRepaymentTypeLabel={ variableRepaymentTypeLabel }
                />
              }
            />
            { (interestType === 'fixed') &&
              <GreyBig size='4' grey='Fixed loan term' big={ fixedInterestPeriodLabel }/>
            }
            <GreyBig size='4' grey='Overall loan term' big={ overallLoanTermLabel }/>
            { (interestType === 'variable') &&
              <GreyBig size='4' grey='Offset account' big={ offsetAccountLabel }/>
            }
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  loanDetail: state.review.loanDetail,
})

export default connect(mapStateToProps, {
})(Details)
